import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'

const data = (state: RootState) => state.pubWaterSystem.data
const loading = (state: RootState) => state.pubWaterSystem.loading
const error = (state: RootState) => state.pubWaterSystem.error

const eventMilestones = {
  data: (state: RootState) => state.pubWaterSystem.eventMilestones.data,
  loading: (state: RootState) => state.pubWaterSystem.eventMilestones.loading,
  error: (state: RootState) => state.pubWaterSystem.eventMilestones.error,
}

const name = (state: RootState) =>
  state.pubWaterSystem.data ? state.pubWaterSystem.data.PWS_NAME : ''

const makeAddress = createSelector([data], (item) => {
  if (!item) return ''
  const {
    ADDRESS_LINE1: address1,
    ADDRESS_LINE2: address2,
    CITY_NAME: city,
    STATE_CODE: state,
    ZIP_CODE: zip,
  } = item
  return `${address1} ${address2} ${city}, ${state} ${zip}`
})

const makeObjectSummary = createSelector([data, makeAddress], (item, address) => {
  if (!item) return {}
  const {
    PWSID: pwsId,
    PWS_NAME: name,
    POPULATION_SERVED_COUNT: pop_served,
    PRIMARY_SOURCE_CODE: prim_source,
    SERVICE_CONNECTIONS_COUNT: svc_connections,
          OWNER_TYPE_CODE: owner_type,
  } = item
  return {
    pwsId,
    address,
    name,
    pop_served,
    prim_source,
    svc_connections,
    owner_type
  }
})

export const PubWaterSystemSelector = {
  data,
  loading,
  error,
  name,
  makeAddress,
  makeObjectSummary,
  eventMilestones,
}
